<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        small
        v-on="on"
      >
        Create Claim Setting Detail
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Entitlement Setting Detail"
      text="Create Claim Entitlement Setting Detail"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="jobCategory"
                v-validate="'required'"
                :items="filteredJobCategories"
                label="Job Category"
                :error-messages="errors.collect('jobCategory')"
                data-vv-name="jobCategory"   
                data-vv-as="job category"   
                item-text="name"
                item-value="id"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="maxAmount"
                v-validate="'required|validAmount'"
                v-money="money"
                :error-messages="errors.collect('maxAmount')"
                data-vv-as="amount"
                data-vv-name="maxAmount"
                label="Maximum Claim Amount"
                prefix="RM"
                :suffix="'/' + creditUnit"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimEntitlementSetting: {
        type: Object,
        required: true,
      },
      jobCategories: {
        type: Array,
        required: true,
      },
      creditUnit: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        jobCategory: null,
        maxAmount: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      filteredJobCategories () {
        const usedIds = this.claimEntitlementSetting.claim_entitlement_setting_details.map(d => d.job_category_id)
        return this.jobCategories.filter(category => !usedIds.includes(category.id))
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.$validator.extend('validAmount', {
          getMessage (field, args) {
            return 'Amount should be more than 0'
          },
          validate (value, args) {
            return value.toString().replaceAll(',', '') > 0
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.claimEntitlementSettingDetails().create(this.prepareFormData())
            .then(response => {
              this.$emit('created', response.data)
              this.$snack({ message: 'Added new claim entitlement setting detail' })

              this.dialog = false
            })
            .catch((err) => {
              if (err.response.status === 422) {              
                this.$snack({ 
                  color: 'error',
                  message: err.response.data.message, 
                })
              }

              if (err.response.status === 500) {              
                this.$snack({ 
                  color: 'error',
                  message: err.response.data.status, 
                })
              }
            
              this.progressing = false
            })    
            .then(() => {
              this.progressing = false
            })
        })
      },
      prepareFormData () {
        return {
          claim_entitlement_setting_id: this.claimEntitlementSetting.id,
          job_category_id: this.jobCategory,
          max_amount: this.maxAmount,
        }
      },
    },
  }
</script>
